import CreateFirstProduct from './CreateFirstProductContainer'
import { SelectCategoryModal } from './components'

CreateFirstProduct.Modal = SelectCategoryModal

export default CreateFirstProduct;